/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ErrorCode = {
  type: 'Enum',
} as const;
